import { MONEDA_HISTORICA, RENTAS_AUTONOMOS, TABLA_TOPES } from '../config/normativaDictamen.js'

function normalizePeriodoKey(periodo) {
  if (!periodo) return ''
  const value = String(periodo).trim()
  const slashMatch = value.match(/^(\d{2})\/(\d{4})$/)
  if (slashMatch) return `${slashMatch[2]}-${slashMatch[1]}`
  const isoMonth = value.match(/^(\d{4})-(\d{2})/)
  if (isoMonth) return `${isoMonth[1]}-${isoMonth[2]}`
  return value
}

function toYearMonthNumber(periodo) {
  const key = normalizePeriodoKey(periodo)
  const match = key.match(/^(\d{4})-(\d{2})$/)
  if (!match) return null
  const year = Number(match[1])
  const month = Number(match[2])
  if (!year || !month) return null
  return year * 100 + month
}

function toNumber(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0
  if (value == null) return 0
  const cleaned = String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')
  const parsed = Number(cleaned)
  return Number.isFinite(parsed) ? parsed : 0
}

export default function aplicarNormativaAnses(dataJson, configUsuario = {}) {
  const rows = Array.isArray(dataJson)
    ? dataJson
    : Array.isArray(dataJson?.remuneraciones)
      ? dataJson.remuneraciones
      : []

  const baseImponibleMaxima = configUsuario.baseImponibleMaxima || TABLA_TOPES
  const rentasReferencia = configUsuario.rentasReferencia || RENTAS_AUTONOMOS
  const ceseYearMonth = configUsuario.fechaCese ? toYearMonthNumber(configUsuario.fechaCese) : null

  const normalizarMonedaHistorica = (monto, row) => {
    const key = normalizePeriodoKey(row.periodo || row.periodoISO)
    const year = Number(key.slice(0, 4))
    const moneda = String(row.moneda || '').toLowerCase()

    if (moneda.includes('austral') || year < 1985) {
      return monto / MONEDA_HISTORICA.australesAHiperpesos / MONEDA_HISTORICA.hiperpesosAPesosLey23928
    }
    if (moneda.includes('hiper') || (year >= 1985 && year <= 1991)) {
      return monto / MONEDA_HISTORICA.hiperpesosAPesosLey23928
    }
    return monto
  }

  return rows.map((row) => {
    const periodo = row.periodo || row.periodoISO || row.month || ''
    const periodoKey = normalizePeriodoKey(periodo)
    const montoBase = toNumber(row.monto ?? row.remImpSS ?? row.remuneracion)
    const montoOriginal = normalizarMonedaHistorica(montoBase, row)

    const periodoYearMonth = toYearMonthNumber(periodo)
    const esPosteriorACese = Boolean(
      ceseYearMonth && periodoYearMonth && periodoYearMonth > ceseYearMonth
    )

    const flagMonotributo = Boolean(
      row.monotributo === true ||
      String(row.tipoActividad || '').toLowerCase().includes('monotributo')
    )

    let montoLegal = montoOriginal
    const montoRealSinTope = montoOriginal
    let isTopado = false
    let fuenteNormativa = 'original'

    if (flagMonotributo) {
      const categoria = String(row.categoriaMonotributo || row.categoria || '').toUpperCase().trim()
      const rentaPeriodo = rentasReferencia[periodoKey] || {}
      const renta = toNumber(rentaPeriodo[categoria])
      if (renta > 0) {
        montoLegal = renta
        fuenteNormativa = 'renta_monotributo'
      }
    }

    const tope = toNumber(baseImponibleMaxima[periodoKey])
    if (tope > 0 && montoLegal > tope) {
      montoLegal = tope
      isTopado = true
      fuenteNormativa = 'tope_base_imponible'
    }

    return {
      ...row,
      periodoKey,
      montoOriginal,
      montoSujetoAAporte: montoLegal,
      montoRealSinTope,
      isTopado,
      fuenteNormativa,
      invalidoPorCese: esPosteriorACese,
      incluirEnPromedio: !esPosteriorACese,
      motivoExclusion: esPosteriorACese ? 'Excluido por Cese' : '',
      periodoYearMonth,
    }
  })
}
